module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        var ticketType = $('#issue-type');
        var contractors = $('#contractor');
        var contractorContacts = $('#contractor-contact');

        var htmlEmptyContractorOption = '<option selected="selected" value="">--- Select contractor ---</option>';
        var htmlEmptyContractorContactOption = '<option selected="selected" value="">--- Select contractor contact ---</option>';

        /*********************************
         * POPULATE CONTRACTOR DROPDOWNS *
         *********************************/
        /** Ticket type select event function to populate Contractors */
        function populateContractors ()
        {
            if ( $(this).val() != 0 ) {

                /** Clear dependend dropdowns */
                contractors.find('option').remove();
                contractorContacts.find('option').remove();
                contractorContacts.html(htmlEmptyContractorContactOption);

                /** Prepare and run AJAX*/
                var url = '/api/contractors/findAllByService';
                var data = { id: ticketType.val() };

                var success = function (response) {

                    /** Populate contractors dropdown */
                    var listItems = htmlEmptyContractorOption;
                    for (var i = 0; i < response.contractors.length; i++) {
                        listItems += "<option value='"+response.contractors[i].id+"'>"+response.contractors[i].name+"</option>";
                    }
                    contractors.html(listItems);
                }

                var error = function (response) {
                    console.log('Error');
                }

                /** Send AJAX request */
                AjaxController.prototype.send(url, data, success, error);
            }
        }


        /** Contractors select change event function to populate Contractor contacts */
        function populateContacts ()
        {
            if ( $(this).val() != 0 ) {

                /** Clear dependend dropdowns */
                contractorContacts.find('option').remove();

                /** Prepare and run AJAX*/
                var url = '/api/contractors/findContactsByContractorId';
                var data = { id: contractors.val() };

                var success = function (response) {

                    /** Populate contacts dropdown*/
                    var listItems = htmlEmptyContractorContactOption;
                    for (var i = 0; i < response.contacts.length; i++) {
                        listItems += "<option value='"+response.contacts[i].id+"'>"+response.contacts[i].name+"</option>";
                    }

                    console.log('list of contractor contacts');
                    console.log(listItems);

                    contractorContacts.html(listItems);
                }

                var error = function (response) {
                    console.log('Error');
                }

                /** Send AJAX request */
                AjaxController.prototype.send(url, data, success, error);
            }
        };


        /******************
         * EVENT HANDLERS *
         ******************/
        ticketType.on('change', populateContractors );
        contractors.on('change', populateContacts );


    });
}();
